import * as React from 'react';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import { PickupPointsContainer } from './PickupPointsContainer.js';
import { PickupStoresContainer } from './PickupStoresContainer.js';

const SelectedShippingMethodContainer = ({ selectedShippingMethod , warningMessageOnly =false , hideTitle =false , selectedStore , onStoreSelect , onPickupPointSelect , selectedPickupPoint , onShippingModalClose  })=>{
    switch(selectedShippingMethod){
        case ShippingMethod.Pickup:
            return /*#__PURE__*/ React.createElement(PickupStoresContainer, {
                hideTitle: hideTitle,
                warningMessageOnly: warningMessageOnly,
                selectedStore: selectedStore,
                onStoreSelect: onStoreSelect,
                onShippingModalClose: onShippingModalClose
            });
        case ShippingMethod.PickupPoint:
            return /*#__PURE__*/ React.createElement(PickupPointsContainer, {
                hideTitle: hideTitle,
                warningMessageOnly: warningMessageOnly,
                onPickupPointSelect: onPickupPointSelect,
                selectedPickupPoint: selectedPickupPoint,
                onShippingModalClose: onShippingModalClose
            });
        default:
            return null;
    }
};

export { SelectedShippingMethodContainer };
//# sourceMappingURL=SelectedShippingMethodContainer.js.map
